<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <div class="d-flex align-items-center">
                                <div class="edit">
                                    <button (click)="backToChangeRequest()">
                                        <span><i class="ri-arrow-left-line"></i></span>
                                    </button>
                                </div>
                                <h3 class="px-3">Change Request</h3>
                            </div>
                        </div>                   
                    </div>

                    <div class="canvas-data">
                        <form [formGroup]="changeRequestForm" >
                            <div class="row">
                                                          
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="title">
                                            <label class="floating-label">Title</label>
                                            <i class="ri-file-list-line"></i>
                                        </div>
                                        <mat-error *ngIf="f.title.invalid && (f.title.touched || f.title.dirty)" class="alert alert-danger">
                                            <mat-error *ngIf="f.title.errors.required">
                                                Title is required
                                            </mat-error>
                                        </mat-error> 
                                    </div>
                                </div>
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="status">
                                                <!-- <option value="" disabled selected>Select status</option> -->
                                                <option value="Phone call">Phone call</option>
                                                <option value="Meeting">Meeting</option>
                                                <option value="Email">Email</option>
                                            </select>
                                            <label for="status" class="floating-label floating-label-special">Status</label>
                                            <i class="ri-stack-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="changeRequestNumber" disabled>
                                            <label class="floating-label floating-label-special" *ngIf="!this.currentId">Change Request Number</label>
                                            <i class="ri-file-list-3-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="causedBy">
                                            <label class="floating-label">Caused By</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                        <mat-error *ngIf="f.causedBy.invalid && (f.causedBy.touched || f.causedBy.dirty)" class="alert alert-danger">
                                            <mat-error *ngIf="f.causedBy.errors.required">
                                              Caused By is required
                                            </mat-error>
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="partClassification">
                                            <label class="floating-label">Part Classification</label>
                                            <i class="ri-shield-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="crResponsibility">
                                            <label class="floating-label">CR Responsibility</label>
                                            <i class="ri-user-follow-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="schedule">
                                            <label class="floating-label">Schedule</label>
                                            <i class="ri-shield-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="problem">
                                            <label class="floating-label">Problem</label>
                                            <i class="ri-file-list-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="solution">
                                            <label class="floating-label">Solution</label>
                                            <i class="ri-shield-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="impactDirectMaterialCost">
                                            <label class="floating-label">Impact Direct Material Cost</label>
                                            <i class="ri-calendar-check-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="impactRndOneOffCost">
                                            <label class="floating-label">Impact RndOne OffCost</label>
                                            <i class="ri-information-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="impactDirectLaborCost">
                                            <label class="floating-label">Impact Direct LaborCost</label>
                                            <i class="ri-file-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="impactPlantInvestment">
                                            <label class="floating-label">Impact Plant Investment</label>
                                            <i class="ri-24-hours-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="impactOthers">
                                            <label class="floating-label">Impact Others</label>
                                            <i class="ri-time-line"></i>
                                        </div>
                                    </div>
                                </div>   
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="impactTransferPrice">
                                            <label class="floating-label">Impact Transfer Price</label>
                                            <i class="ri-recycle-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="impactCostBaringUseCase">
                                            <label class="floating-label">Impact Cost Bearing Use Case</label>
                                            <i class="ri-line-chart-line"></i>
                                        </div>
                                    </div>
                                </div>    
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="impactWeight">
                                            <label class="floating-label">Impact Weight</label>
                                            <i class="ri-line-chart-line"></i>
                                        </div>
                                    </div>
                                </div> 
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="impactOtherTarget">
                                            <label class="floating-label">Impact Other Target</label>
                                            <i class="ri-line-chart-line"></i>
                                        </div>
                                    </div>
                                </div> 
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="requiredChangesForCn">
                                            <label class="floating-label">Required Changes For CN</label>
                                            <i class="ri-line-chart-line"></i>
                                        </div>
                                    </div>
                                </div> 
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="requiredChangesForEceRhd">
                                            <label class="floating-label">Required Changes For EceRhd</label>
                                            <i class="ri-line-chart-line"></i>
                                        </div>
                                    </div>
                                </div> 
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="requiredChangesForEceLhd">
                                            <label class="floating-label">Required Changes For EceLhd</label>
                                            <i class="ri-line-chart-line"></i>
                                        </div>
                                    </div>
                                </div>                      
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="requiredChangesForFeatureList">
                                            <label class="floating-label">Required Changes For Feature List</label>
                                            <i class="ri-line-chart-line"></i>
                                        </div>
                                    </div>
                                </div> 
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="requiredChangesForCbom">
                                            <label class="floating-label">Required Changes For CBOM</label>
                                            <i class="ri-line-chart-line"></i>
                                        </div>
                                    </div>
                                </div> 
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="requiredChangesForEarlyBom">
                                            <label class="floating-label">Required Changes For Early BOM</label>
                                            <i class="ri-line-chart-line"></i>
                                        </div>
                                    </div>
                                </div> 
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="requiredChangesForHomologationRelevant">
                                            <label class="floating-label">Required Changes For Homologation Relevant</label>
                                            <i class="ri-line-chart-line"></i>
                                        </div>
                                    </div>
                                </div> 
                                <div class="col-sm-4 mb-2">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text"  formControlName="requiredChangesForAffectedFeature">
                                            <label class="floating-label">Required Changes For Affected Feature</label>
                                            <i class="ri-line-chart-line"></i>
                                        </div>
                                    </div>
                                </div> 
                                <div class="col-sm-8 mb-2">
                                    <div class="text-end">
                                      <a class="btn" (click)="backToChangeRequest()" *ngIf="this.currentId">Cancel</a>
                                      <a class="btn" (click)="updateCR()" [class.disabled]="!changeRequestForm.valid?true:null" *ngIf="this.currentId">Update</a>
                                    </div>
                                  </div>
                                <div class="col-sm-12 mb-2">
                                    <div class="text-end">
                                        <div class="d-flex gap-2 justify-content-end">
                                            <a class="btn" (click)="backToChangeRequest()" *ngIf="!this.currentId">Cancel</a>
                                            <a class="btn" (click)="createCR()" [class.disabled]="!changeRequestForm.valid?true:null" *ngIf="!this.currentId">Create</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </section>
    </article>
</main>
